import { Modal, Button } from '@ets/design-system';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from '_common/hooks';
import { closeAndResetModal } from '_common/modals/ModalsSlice';
import {
  activateOnboarding,
  setFirstAccessModalAllowed,
  setFirstAccessModalSeen,
  setManualStartOnboarding,
  startOnboarding,
} from 'App/redux/onboardingSlice';
import { useOnboardingStatusMutation } from 'App/redux/onboardingApi';
import { selectIsIEnvision } from 'App/redux/appSlice';

const FirstAccessModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.modals.open.FirstAccessModal);
  const location = useSelector((state) => state.modals.FirstAccessModal?.location);
  const [sendOnboardingStatus] = useOnboardingStatusMutation();
  const isIEnvision = useSelector(selectIsIEnvision);

  const close = () => {
    dispatch(setFirstAccessModalSeen(true));
    dispatch(setFirstAccessModalAllowed(false));
    sendOnboardingStatus({ target: location, step: 'ending' });
    dispatch(closeAndResetModal('FirstAccessModal'));
  };

  const handleStartOnboarding = () => {
    dispatch(setFirstAccessModalSeen(true));
    dispatch(setFirstAccessModalAllowed(true));
    dispatch(setManualStartOnboarding(true));
    dispatch(startOnboarding(location));
    dispatch(activateOnboarding(location));
    dispatch(closeAndResetModal('FirstAccessModal'));
  };

  return (
    <Modal width="72.375rem" open={!!isOpen} testId="first-access" close={close}>
      <Modal.Header>
        <FormattedMessage id="FIRST_ACCESS_MODAL_TITLE" />
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-8">
          <div>
            <FormattedMessage
              id={
                isIEnvision
                  ? 'FIRST_ACCESS_MODAL_FIRST_TEXT'
                  : 'FIRST_ACCESS_MODAL_FIRST_TEXT_DODOC'
              }
            />
          </div>
          <div>
            <FormattedMessage id="FIRST_ACCESS_MODAL_SECOND_TEXT" />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="m"
          onClick={handleStartOnboarding}
          variant="standard"
          testId="first-access-start-onboarding"
          className="mr-4"
        >
          <FormattedMessage id="START_ONBOARDING" />
        </Button>
        <Button
          size="m"
          variant="primary"
          onClick={close}
          testId="first-access-continue-with-review"
        >
          <FormattedMessage id="CONTINUE_WITH_REVIEW" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FirstAccessModal;
